import { Boost, Empower, Engage, Gymautomated, Gymcomprehensive, Gymmobile, Gympage, Gymperformance, Gymsecure, Support } from "../assets/images/images";

const gymData = {
    heading: "The Best Software for Gym Management",
    subtitle:
        "EasyMembr offers robust billing, centralized member management, and seamless staff check-in. It supports flexible workout plans and easy session booking, helping gyms boost member engagement and attendance.",
    trialText: "Get Started Now",
    demoText: "Request a Demo",
    imageSrc: Gympage,
    FeatureHead: "Gym Management: Streamlined Operations and Member Retention",
    FeatureDesc: "Explore the powerful features designed to elevate your gym's performance and efficiency.",
    FeaturesDetails: [
        {
            id: 1,
            title: "Automated Class and Trainer Scheduling",
            description: [
                "Manage gym sessions, personal training, and group classes with a user-friendly scheduler.",
                "Handle reschedules, cancellations, and waiting lists efficiently.",
                "Allow clients to book sessions anytime via web app, increasing convenience and loyalty.",
            ],
            image: Gymautomated
        },
        {
            id: 2,
            title: "Comprehensive Member Profiles and Secure Data",
            description: [
                "Store member details including fitness goals, attendance, and preferences.",
                "Leverage data for personalized training and improved service.",
                "Ensure data privacy and security with industry-standard compliance.",
            ],
            image: Gymcomprehensive
        },
        {
            id: 3,
            title: "Secure Payments and Membership Management",
            description: [
                "Integrate with major payment gateways for hassle-free transactions.",
                "Automate billing, invoicing, and receipts to reduce admin time.",
                "Easily manage recurring and one-time membership plans.",
            ],
            image: Gymsecure
        },
        {
            id: 4,
            title: "Performance Insights and Reporting Tools",
            description: [
                "Track KPIs like revenue, class attendance, and retention rates.",
                "Generate custom reports to monitor gym growth and optimize strategy.",
                "Use insights to improve services and make informed decisions.",
            ],
            image: Gymperformance
        },
        {
            id: 5,
            title: "Mobile Access and Real-Time Communication",
            description: [
                "Offer a branded web app for members to manage schedules and payments.",
                "Send automated reminders and notifications for upcoming classes.",
                "Enable trainers to access schedules and member info on-the-go.",
            ],
            image: Gymmobile
        },
    ],
    HighlighCardDetails: [
        {
            id: 1,
            subtitle: "ALL-IN-ONE GYM SOFTWARE",
            title: "Book a Free Demo",
            description: [
                "No more manual tracking! Experience the benefits of EasyMembr Gym Management Software with a free trial."
            ],
            links: ["Start Your Free Trial", "Book a Demo", "View Pricing"],
        },
    ],
    AdvantageHeadText: "Why Choose EasyMembr Gym Management Software?",
    AdvantageDescText:
        "EasyMembr solution simplifies gym operations, boosts client engagement, and supports your business growth with powerful features.",
    featuresData: [
        {
            title: "Seamless System Integration",
            description: [
                "EasyMembr support team ensures smooth migration from existing software.",
                "Generate key reports on finances, performance, and client trends.",
                "Customize dashboards for real-time tracking of business health.",
            ],
            icon: Empower
        },
        {
            title: "Member Engagement and Personalization",
            description: [
                "Track member progress and send customized fitness content.",
                "Offer tailored plans, discounts, and fitness tips for better retention.",
                "Keep members engaged with regular communication and health tips.",
            ],
            icon: Engage
        },
        {
            title: "Flexible Class Management",
            description: [
                "Handle online and in-person class bookings with ease.",
                "Automatically update changes to schedules and inform members.",
                "Manage trainer availability, attendance, and waitlists efficiently.",
            ],
            icon: Boost
        },
        {
            title: "Top-Tier Support and Staff Analytics",
            description: [
                "Multilingual support for diverse client bases.",
                "Quick responses from EasyMembr dedicated helpdesk.",
                "Monitor trainer performance and improve service delivery.",
            ],
            icon: Support
        },
    ],
};

export default gymData;
